"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = AsyncEcommerceSettingsContainer;

var _react = _interopRequireDefault(require("react"));

var _Loadable = _interopRequireDefault(require("UIComponents/decorators/Loadable"));

var _UILoadingSpinner = _interopRequireDefault(require("UIComponents/loading/UILoadingSpinner"));

var EcommerceSettingsContainer = (0, _Loadable.default)({
  loader: function loader() {
    return import('./EcommerceSettingsContainer'
    /* webpackChunkName: "chunk-ecommerce" */
    );
  },
  LoadingComponent: function LoadingComponent() {
    return _react.default.createElement(_UILoadingSpinner.default, {
      grow: true,
      minHeight: 200
    });
  }
});

function AsyncEcommerceSettingsContainer(props) {
  return _react.default.createElement(EcommerceSettingsContainer, props);
}

module.exports = exports.default;